(function () {
  if (window.vdbLandingHeaders) {
    window.vdbLandingHeaders.init(document);
    return;
  }

  const instances = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 990px)');

  function init(scope) {
    const sections = Array.from(scope.querySelectorAll('[data-landing-header]'));
    if (scope.matches && scope.matches('[data-landing-header]')) sections.unshift(scope);
    sections.forEach(function (section) {
      if (instances.has(section)) return;
      const images = Array.from(section.querySelectorAll('.landing-fadeshow img'));
      const features = Array.from(section.querySelectorAll('.feature'));
      const button = section.querySelector('[data-landing-pause]');
      const header = document.querySelector('.header-landing-altered');
      const logo = header && header.querySelector('svg');
      let imageIndex = 0;
      let featureIndex = 0;
      let timer;
      let paused = reducedMotion.matches;
      let disposed = false;
      const previousHeaderStyle = header && header.getAttribute('style');
      const previousLogoStyle = logo && logo.getAttribute('style');

      function show(items, index) {
        items.forEach(function (item, position) {
          item.classList.toggle('active', position === index);
        });
      }

      function refresh() {
        window.clearInterval(timer);
        timer = null;
        if (button) {
          button.hidden = images.length < 2 && (features.length < 2 || !mobile.matches);
          button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
          button.querySelector('[data-pause-symbol]').hidden = paused;
          button.querySelector('[data-play-symbol]').hidden = !paused;
        }
        if (disposed || paused || document.hidden || (images.length < 2 && (!mobile.matches || features.length < 2))) return;
        timer = window.setInterval(function () {
          if (images.length > 1) {
            const nextIndex = (imageIndex + 1) % images.length;
            const nextImage = images[nextIndex];
            nextImage.loading = 'eager';
            // Keep the current photo visible until the next one is ready.
            if (nextImage.complete && nextImage.naturalWidth > 0) {
              imageIndex = nextIndex;
              show(images, imageIndex);
            }
          }
          if (mobile.matches && features.length > 1) {
            featureIndex = (featureIndex + 1) % features.length;
            show(features, featureIndex);
          }
        }, 5000);
      }

      function togglePause() {
        paused = !paused;
        refresh();
      }

      function motionChanged() {
        paused = reducedMotion.matches;
        refresh();
      }

      function updateHeader() {
        if (!header || !logo) return;
        const atTop = window.scrollY < window.innerHeight * 0.9 - 100;
        header.style.backgroundColor = atTop ? '#1d1a1a' : '#d74132';
        logo.style.fill = atTop ? '#ffffff' : '#1d1a1a';
      }

      show(images, imageIndex);
      show(features, featureIndex);
      if (button) button.addEventListener('click', togglePause);
      document.addEventListener('visibilitychange', refresh);
      reducedMotion.addEventListener('change', motionChanged);
      mobile.addEventListener('change', refresh);
      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader();
      refresh();
      instances.set(section, function () {
        disposed = true;
        window.clearInterval(timer);
        if (button) button.removeEventListener('click', togglePause);
        document.removeEventListener('visibilitychange', refresh);
        reducedMotion.removeEventListener('change', motionChanged);
        mobile.removeEventListener('change', refresh);
        window.removeEventListener('scroll', updateHeader);
        if (header) {
          if (previousHeaderStyle === null) header.removeAttribute('style');
          else header.setAttribute('style', previousHeaderStyle);
        }
        if (logo) {
          if (previousLogoStyle === null) logo.removeAttribute('style');
          else logo.setAttribute('style', previousLogoStyle);
        }
        instances.delete(section);
      });
    });
  }

  window.vdbLandingHeaders = { init: init };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, section) {
      if (event.target === section || event.target.contains(section)) dispose();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
})();
